module.exports = __webpack_public_path__ + "static/015.thumb-15b69b354102975d1dda5c1521f422fe.jpg";